// @owners { team: patient-health }
import { getDeliveriesForPrescriptionID } from '~shared/features/delivery/selectors/getDeliveriesForPrescriptionID';
import getErrors from '~shared/features/ui/selectors/getErrors';
import getLoading from '~shared/features/ui/selectors/getLoading';
import { connect } from '~shared/store';
import { ArchivePrescriptionModal } from './ArchivePrescriptionModal';

// @ts-expect-error TS(7006): Parameter 'state' implicitly has an 'any' type.
function mapStateToProps(state, ownProps) {
  const { prescription } = ownProps;
  const errors = getErrors(state);
  const loading = getLoading(state);
  const deliveries = getDeliveriesForPrescriptionID(state, {
    prescriptionID: prescription?.id,
  });
  return {
    archivingPrescription: loading.archivePrescriptionLoading,
    archivePrescriptionError: errors.archivePrescriptionError,
    deliveries,
  };
}

export default connect(mapStateToProps)(ArchivePrescriptionModal);
